import { State, Selector, Action, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { PersonnesMoralesService, PersonnesPhysiquesService, BelgesService, EtrangersService, FormesJuridiquesService, SecondesResidencesService, SecondesResidencesPersonnePhysiqueService, TypesDechetsService, DemandesQuotasSupplementairesPersonneMoraleService, DemandesQuotasSupplementairesPersonnePhysiqueService, PlaquesPersonnePhysiqueService } from 'src/api/services';
import { BelgeDto, DemandeQuotaSupplementaireDto, EtrangerDto, PersonneMoraleDto, PersonnePhysiqueDto, SecondeResidenceDto, TypeDechetDto, TypePersonnePhysiqueValues, PlaquePersonnePhysiqueDto } from 'src/api/models';
import { tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { VisiteursState, VisiteursStateDefault } from './visiteurs.state';
import { Visiteurs } from './visiteurs.actions';
import { state } from '@angular/animations';
@State<VisiteursState>({
  name: 'visiteurs',
  defaults: VisiteursStateDefault,
})
@Injectable()
export class VisiteursStore {

  constructor(private personnesMoralesService: PersonnesMoralesService,
    private personnesPhysiquesService: PersonnesPhysiquesService,
    private belgeService: BelgesService,
    private etrangersService: EtrangersService,
    private formesJuridiquesService: FormesJuridiquesService,
    private secondeResidenceService: SecondesResidencesService,
    private secondesResidencesPersonnePhysiqueService : SecondesResidencesPersonnePhysiqueService,
    private demandesQuotasPMService : DemandesQuotasSupplementairesPersonneMoraleService,
    private demandesQuotasPPService : DemandesQuotasSupplementairesPersonnePhysiqueService,
    private typesDechetsService : TypesDechetsService, 
    private plaquesPersonnePhysiqueService : PlaquesPersonnePhysiqueService) { }

  @Selector()
  static personnePhysique$(state: VisiteursState) {
    return state.personnePhysique;
  }

  @Selector()
  static belge$(state: VisiteursState) {
    return state.belge;
  }

  @Selector()
  static etranger$(state: VisiteursState) {
    return state.etranger;
  }

  @Selector()
  static personneMorale$(state: VisiteursState) {
    return state.personneMorale;
  }

  @Selector()
  static secondeResidence$(state: VisiteursState) {
    return state.secondeResidence;
  }

  @Selector()
  static typesDechets$(state: VisiteursState) {
    return state.typesDechets;
  }

  @Selector()
  static error$(state: VisiteursState) {
    return state.error;
  }

  @Selector()
    static plaquePersonnePhysique$(state : VisiteursState){
      return state.plaquePersonnePhysique;
    }
  

  @Action(Visiteurs.DeleteFormeJuridique)
  deleteFormeJuridique({ patchState }: StateContext<VisiteursState>, { fj }: Visiteurs.DeleteFormeJuridique) {
    return this.formesJuridiquesService.formeJuridiqueDelete({ id: fj.Id }).pipe(
      tap((res: number) => {
        patchState({
          error: null
        });
      }),
        catchError((error: Error) => {
        patchState({
          error: error.message
        });
        return of(error);
      })
    );
  }

  // Personne Physique
  @Action(Visiteurs.DesactivatePP)
  desactivatePP( { patchState }: StateContext<VisiteursState>, { personnePhysique }: Visiteurs.DesactivatePP) {
    switch(personnePhysique.Type) {
      case TypePersonnePhysiqueValues.Belge:
        return this.belgeService.belgeDesactivate({ id: personnePhysique.Id, body: personnePhysique }).pipe(
          tap( (res: number) => {
            patchState({
              personnePhysique: null,
              error: null
            });
          }),
          catchError( (error: Error) => {
            patchState({
              personnePhysique: null,
              error: error.message
            });
            return of(error);
          })
        );
      case TypePersonnePhysiqueValues.Etranger:
        return this.etrangersService.etrangerDesactivate({ id: personnePhysique.Id, body: personnePhysique }).pipe(
          tap( (res: number) => {
            patchState({
              personnePhysique: null,
              error: null
            });
          }),
          catchError( (error: Error) => {
            patchState({
              personnePhysique: null,
              error: error.message
            });
            return of(error);
          })
        );
      default:
        // Throw error;
    }
  }

  @Action(Visiteurs.ExcludePP)
  excludePP( { patchState }: StateContext<VisiteursState>, { personnePhysique }: Visiteurs.ExcludePP) {
    switch(personnePhysique.Type) {
      case TypePersonnePhysiqueValues.Belge:
        return this.belgeService.belgeSetExclu({ id: personnePhysique.Id, body: personnePhysique }).pipe(
          tap( (res: BelgeDto) => {
            patchState({
              personnePhysique: null,
              error: null
            });
          }),
          catchError( (error: Error) => {
            patchState({
              personnePhysique: null,
              error: error.message
            });
            return of(error);
          })
        );
      case TypePersonnePhysiqueValues.Etranger:
        return this.etrangersService.etrangerSetExclu({ id: personnePhysique.Id, body: personnePhysique.EstExclu }).pipe(
          tap( (res: EtrangerDto) => {
            patchState({
              personnePhysique: null,
              error: null
            });
          }),
          catchError( (error: Error) => {
            patchState({
              personnePhysique: null,
              error: error.message
            });
            return of(error);
          })
        );
      default:
        // Throw error;
    }
  }

  @Action(Visiteurs.GetPPDetail)
  getPPDetail( { patchState }: StateContext<VisiteursState>, { personnePhysiqueId }: Visiteurs.GetPPDetail) {
    return this.personnesPhysiquesService.personnePhysiqueGet({ id: personnePhysiqueId }).pipe(
      tap( (res: PersonnePhysiqueDto) => {
        patchState({
          personnePhysique: res,
          error: null
        });
      }),
      catchError( (error: Error) => {
        patchState({
          personnePhysique: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.GetBelgeDetail)
  getBelgeDetail( { patchState }: StateContext<VisiteursState>, { personnePhysiqueId }: Visiteurs.GetBelgeDetail) {
    return this.belgeService.belgeGet({ id: personnePhysiqueId }).pipe(
      tap( (res: BelgeDto) => {
        patchState({
          belge: res,
          error: null
        });
      }),
      catchError( (error: Error) => {
        patchState({
          belge: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.GetEtrangerDetail)
  getEtrangerDetail( { patchState }: StateContext<VisiteursState>, { personnePhysiqueId }: Visiteurs.GetEtrangerDetail) {
    return this.etrangersService.etrangerGet({ id: personnePhysiqueId }).pipe(
      tap( (res: EtrangerDto) => {
        patchState({
          etranger: res,
          error: null
        });
      }),
      catchError( (error: Error) => {
        patchState({
          etranger: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.UpdatePPDetail)
  updatePPDetail( { patchState }: StateContext<VisiteursState>, { personnePhysique }: Visiteurs.UpdatePPDetail) {
    switch(personnePhysique.Type) {
      case TypePersonnePhysiqueValues.Belge:
        return this.belgeService.belgePut({ id: personnePhysique.Id, body: personnePhysique }).pipe(
          tap( (res: BelgeDto) => {
            patchState({
              personnePhysique: res,
              error: null
            });
          }),
          catchError( (error: Error) => {
            patchState({
              personnePhysique: null,
              error: error.message
            });
            return of(error);
          })
        );
      case TypePersonnePhysiqueValues.Etranger:
        return this.etrangersService.etrangerPut({ id: personnePhysique.Id, body: personnePhysique }).pipe(
          tap( (res: EtrangerDto) => {
            patchState({
              personnePhysique: res,
              error: null
            });
          }),
          catchError( (error: Error) => {
            patchState({
              personnePhysique: null,
              error: error.message
            });
            return of(error);
          })
        );
      default:
        // Throw error;
    }
  }

  @Action(Visiteurs.CreateEtrangerCodes)
  createEtrangerQRCode( { patchState }: StateContext<VisiteursState>, { etrangerId }: Visiteurs.CreateEtrangerCodes) {
    return this.etrangersService.etrangerGenerateEtrangerCodes({ etrangerId }).pipe(
      tap( (res: EtrangerDto) => {
        patchState({
          etranger: res,
          error: null
        });
      }),
      catchError( (error: Error) => {
        patchState({
          etranger: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.CreateBelge)
  createBelge({ patchState }: StateContext<VisiteursState>, { belge }: Visiteurs.CreateBelge) {
    return this.belgeService.belgePost({ body: belge }).pipe(
      tap( (res: BelgeDto) => {
        patchState({
          belge: res,
          error: null
        });
      }),
      catchError( (error: Error) => {
        patchState({
          belge: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.IsAlreadyExistBelge)
  isAlreadyExistBelge({ patchState }: StateContext<VisiteursState>, { prenom, nom, dateDeNaissance }: Visiteurs.IsAlreadyExistBelge) {
    return this.belgeService.belgeIsAlreadyExist({ firstName: prenom, lastname: nom, birthday: dateDeNaissance }).pipe(
      tap( (res: BelgeDto) => {
        patchState({
          belge: res,
          error: null
        });
      }),
      catchError( (error: Error) => {
        patchState({
          belge: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.IsAlreadyExistEtranger)
  isAlreadyExistEtranger({ patchState }: StateContext<VisiteursState>, { prenom, nom, dateDeNaissance }: Visiteurs.IsAlreadyExistEtranger) {
    return this.etrangersService.etrangerIsAlreadyExist({ firstName: prenom, lastname: nom, birthday: dateDeNaissance }).pipe(
      tap( (res: EtrangerDto) => {
        patchState({
          etranger: res,
          error: null
        });
      }),
      catchError( (error: Error) => {
        patchState({
          etranger: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.CreateEtranger)
  createEtranger( { patchState }: StateContext<VisiteursState>, { etranger }: Visiteurs.CreateEtranger) {
    return this.etrangersService.etrangerPost({ body: etranger }).pipe(
      tap( (res: EtrangerDto) => {
        patchState({
          etranger: res,
          error: null
        });
      }),
      catchError( (error: Error) => {
        patchState({
          etranger: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  // Personne Morale
  @Action(Visiteurs.DesactivatePM)
  desactivatePM( { patchState }: StateContext<VisiteursState>, { personneMorale }: Visiteurs.DesactivatePM) {
    return this.personnesMoralesService.personnesMoralesDesactivate({ id: personneMorale.Id, body: personneMorale }).pipe(
      tap( (res: number) => {
        patchState({
          personneMorale: null,
          error: null
        });
      }),
      catchError( (error: Error) => {
        patchState({
          personneMorale: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.GetPMDetail)
  getPMDetail( { patchState }: StateContext<VisiteursState>, { personneMoraleId }: Visiteurs.GetPMDetail) {
    return this.personnesMoralesService.personnesMoralesGet({ id: personneMoraleId }).pipe(
      tap( (res: PersonneMoraleDto) => {
        patchState({
          personneMorale: res,
          error: null
        });
      }),
      catchError( (error: Error) => {
        patchState({
          personneMorale: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.UpdatePMDetail)
  updatePMDetail( { patchState }: StateContext<VisiteursState>, { personneMorale }: Visiteurs.UpdatePMDetail) {
    return this.personnesMoralesService.personnesMoralesPut({ id: personneMorale.Id, body: personneMorale }).pipe(
      tap( (res: PersonneMoraleDto) => {
        patchState({
          personneMorale: res,
          error: null
        });
      }),
      catchError( (error) => {
        const errorMessage = error.error ?? "";
        patchState({
          personneMorale: null,
          error: errorMessage
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.CreatePM)
  createPM( { patchState }: StateContext<VisiteursState>, { personneMorale }: Visiteurs.CreatePM) {
    return this.personnesMoralesService.personnesMoralesPost({ body: personneMorale }).pipe(
      tap( (res: PersonneMoraleDto) => {
        patchState({
          personneMorale: res,
          error: null
        });
      }),
      catchError( (error: Error) => {
        patchState({
          personneMorale: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.CreatePMCodes)
  createPMCodes( { patchState }: StateContext<VisiteursState>, { personneMoraleId }: Visiteurs.CreatePMCodes) {
    return this.personnesMoralesService.personnesMoralesGeneratePmCodes({personneMoraleId: personneMoraleId}).pipe(
      tap( (res: PersonneMoraleDto) => {
        patchState({
          personneMorale: res,
          error: null
        });
      }),
      catchError( (error: Error) => {
        patchState({
          personneMorale: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  // S E C O N D E   R E S I D E N C E
  @Action(Visiteurs.GetSecondeResidenceDetail)
  getSecondeResidenceDetail({ patchState }: StateContext<VisiteursState>, { secondeResidenceId }: Visiteurs.GetSecondeResidenceDetail) {
    return this.secondeResidenceService.secondesResidencesGet({ id: secondeResidenceId }).pipe(
      tap((res: SecondeResidenceDto) => {
        patchState({
          secondeResidence: res,
          error: null
        });
      }),
      catchError((error: Error) => {
        patchState({
          secondeResidence: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.UpdateSecondeResidenceDetail)
  updateSecondeResidenceDetail({ patchState }: StateContext<VisiteursState>, { secondeResidence }: Visiteurs.UpdateSecondeResidenceDetail) {
    return this.secondeResidenceService.secondesResidencesPut({ id: secondeResidence.Id, body: secondeResidence }).pipe(
      tap((res: SecondeResidenceDto) => {
        patchState({
          secondeResidence: res,
          error: null
        });
      }),
      catchError((error: Error) => {
        patchState({
          secondeResidence: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.AddSecondResidencePersonne)
  addSecondResidencePersonne({ patchState }: StateContext<VisiteursState>, { personneId, secondeResidence }: Visiteurs.AddSecondResidencePersonne) {
    return this.secondesResidencesPersonnePhysiqueService.secondesResidencesPersonnePhysiquePost( { personnePhysiqueId: personneId, body: secondeResidence }).pipe(
      tap((res) => {
        patchState({
          error: null
        });
      }),
      catchError((error: Error) => {
        patchState({
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.GetTypesDechets)
  getTypesDechets( { patchState}: StateContext<VisiteursState>) {
    return this.typesDechetsService.typeDechetGetList().pipe(
      tap((res: TypeDechetDto[]) => {
        patchState({
          typesDechets: res,
          error: null
        });
      }),
      catchError((error: Error) => {
        patchState({
          typesDechets: null,
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.CreateDemandeQuotaPP)
  createDemandeQuotaPP( { patchState }: StateContext<VisiteursState>, { personnePhysiqueId }: Visiteurs.CreateDemandeQuotaPP ) {
    const dto : DemandeQuotaSupplementaireDto = {
      PersonnePhysiqueId: personnePhysiqueId,
      Montant: 0
    }
    return this.demandesQuotasPPService.demandesQuotasSupplementairesPersonnePhysiquePost( { body: dto }).pipe(
      tap(res => {
        patchState({
          error: null
        });
      }),
      catchError((error: Error) => {
        patchState({
          error: error.message
        });
        return of(error);
      })
    );
  }

  @Action(Visiteurs.CreateDemandeQuotaPM)
  createDemandeQuotaPM( { patchState }: StateContext<VisiteursState>, { personneMoraleId }: Visiteurs.CreateDemandeQuotaPM ) {
    const dto : DemandeQuotaSupplementaireDto = {
      PersonneMoraleId: personneMoraleId,
      Montant: 0
    }
    return this.demandesQuotasPMService.demandesQuotasSupplementairesPersonneMoralePost( { body: dto }).pipe(
      tap(res => {
        patchState({
          error: null
        });
      }),
      catchError((error: Error) => {
        patchState({
          error: error.message
        });
        return of(error);
      })
    );
  }

// Plaques personnes physiques
// @Action(Visiteurs.DesactivatePlaquePP)
// desactivatePlaquePP( { patchState }: StateContext<VisiteursState>, { plaquePersonnePhysique }: Visiteurs.DesactivatePlaquePP) {
//   return this.plaquesPersonnePhysiqueService.plaquesPersonnePhysiqueDesactivate({ id: plaquePersonnePhysique.Id, body: plaquePersonnePhysique }).pipe(
//     tap( (res: number) => {
//       patchState({
//         plaquePersonnePhysique: null,
//         error: null
//       });
//     }),
//     catchError( (error: Error) => {
//       patchState({
//         plaquePersonnesPhysique: null,
//         error: error.message
//       });
//       return of(error);
//     })
//   );
// }

@Action(Visiteurs.GetPlaquePPDetail)
getPlaquePPDetail( { patchState }: StateContext<VisiteursState>, { plaquePersonnePhysiqueId }: Visiteurs.GetPlaquePPDetail) {
  return this.plaquesPersonnePhysiqueService.plaquePersonnePhysiqueGet({ id: plaquePersonnePhysiqueId }).pipe(
    tap( (res: PlaquePersonnePhysiqueDto) => {
      patchState({
        plaquePersonnePhysique: res,
        error: null
      });
    }),
    catchError( (error: Error) => {
      patchState({
        plaquePersonnePhysique: null,
        error: error.message
      });
      return of(error);
    })
  );
}

@Action(Visiteurs.UpdatePlaquePPDetail)
updatePlaquePPDetail( { patchState }: StateContext<VisiteursState>, { plaquePersonnePhysique }: Visiteurs.UpdatePlaquePPDetail) {
  return this.plaquesPersonnePhysiqueService.plaquePersonnePhysiquePut({ id: plaquePersonnePhysique.Id, body: plaquePersonnePhysique }).pipe(
    tap( (res: PlaquePersonnePhysiqueDto) => {
      patchState({
        plaquePersonnePhysique: res,
        error: null
      });
    }),
    catchError( (error) => {
      const errorMessage = error.error ?? "";
      patchState({
        plaquePersonnePhysique: null,
        error: errorMessage
      });
      return of(error);
    })
  );
}

@Action(Visiteurs.CreatePlaquePP)
createPlaquePP( { patchState }: StateContext<VisiteursState>, { plaquePersonnePhysique }: Visiteurs.CreatePlaquePP) {
  return this.plaquesPersonnePhysiqueService.plaquePersonnePhysiquePost({ body: plaquePersonnePhysique }).pipe(
    tap( (res: PlaquePersonnePhysiqueDto) => {
      patchState({
        plaquePersonnePhysique: res,
        error: null
      });
    }),
    catchError( (error: Error) => {
      patchState({
        plaquePersonnePhysique: null,
        error: error.message
      });
      return of(error);
    })
  );
}

}
